export const OptionValues = {
    weightUnits: [
        {
            label: "kgs",
            value: "kgs"
        },
        {
            label: "lbs",
            value: "lbs"
        }
    ],
    themeColor: [
        {
          label: "Orange",
          value: "#E84924"
        },
        {
          label: "Purple",
          value: "#7257E0"
        },
        {
          label: "Magento",
          value: '#28336B'
        },
        {
          label: "Lime",
          value: "#BBE137"
        },
        {
            label: "Gray",
            value: '#1E1E1E'
        },
        {
            label: "Blue",
            value: '#0095F9'
        },
        {
            label: "Winterfresh",
            value: '#ADD5D0'
        },
        {
            label: "Winterfresh-Dark",
            value: '#2A2A2A'
        },
        {
            label: "DC America",
            value: '#732255'
        }
      ],
      timeToSwitch: [
          {
              label: "5",
              value: "5000"
          },
          {
              label: "10",
              value: "10000"
          },
          {
              label: "15",
              value: "15000"
          },
          {
              label: "20",
              value: "20000"
          },
          {
              label: "25",
              value: "25000"
          },
          {
              label: "30",
              value: "30000"
          },
          {
              label: "35",
              value: "35000"
          },
          {
              label: "40",
              value: "40000"
          },
          {
              label: "45",
              value: "45000"
          },
          {
              label: "50",
              value: "50000"
          },
          {
              label: "55",
              value: "55000"
          },
          {
              label: "60",
              value: "60000"
          },
      ],
      scrollSpeed: [
        {
            label: "1",
            value: "1000"
        },
        {
            label: "3",
            value: "3000"
        },
        {
            label: "5",
            value: "5000"
        },
        {
            label: "10",
            value: "10000"
        },
        {
            label: "15",
            value: "15000"
        },
        {
            label: "20",
            value: "20000"
        },
        {
            label: "25",
            value: "25000"
        },
        {
            label: "30",
            value: "30000"
        },
        {
            label: "35",
            value: "35000"
        },
        {
            label: "40",
            value: "40000"
        },
        {
            label: "45",
            value: "45000"
        },
        {
            label: "50",
            value: "50000"
        },
        {
            label: "55",
            value: "55000"
        },
        {
            label: "60",
            value: "60000"
        },
      ],
      distanceNumber: [
          {
                label: "1",
                value: "1"
          },
          {
                label: "2",
                value: "2"
          },
          {
                label: "3",
                value: "3"
          },
          {
                label: "4",
                value: "4"
          },
          {
                label: "5",
                value: "5"
          },
          {
                label: "6",
                value: "6"
          },
          {
                label: "7",
                value: "7"
          },
          {
                label: "8",
                value: "8"
          }
      ]
};

export const AvailableScreenOptions = {
    "daily-wod-2": ["themeColor", "selectedWods", "weightUnits", "distanceNumber"],
    "activity-feed-2": ["themeColor", "selectedWods", "weightUnits", "distanceNumber", "scrollSpeed", "timeToSwitch"],
};